import React from 'react';
export default function EventLogisticsFields({value,onChange,expanded=false}) {
 const Container=expanded?'div':'details';
 return <Container className="svc-event-lite-block">
  {!expanded && <summary>Preparación y traslado</summary>}
  <p>Reserva tiempo antes y después del evento. En blanco se usa el tiempo general del negocio; 0 significa sin tiempo adicional.</p>
  {['bufferBeforeMinutes','bufferAfterMinutes'].map((key,index)=><label className="svc-field" key={key}>
   <span>{index===0?'Antes del evento (minutos)':'Después del evento (minutos)'}</span>
   <input type="number" min="0" max="1440" step="1" value={value[key] ?? ''} onChange={e=>onChange({[key]:e.target.value})}/>
  </label>)}
 </Container>;
}
